export function isActive(user) {
  return user.status === "active";
}
